import type { CaseConfig } from "@/domain/case/case-config";

import type { CaseHistoryEvent } from "./use-case-detail";

/**
 * 判定した人（承認・差し戻しを実行した利用者）。分からなければ null。
 *
 * 判定タスクはモデルごとに名前が違い、metadata にも入っていないので、履歴から
 * **最後に完了した人手タスクの実行者**として導く（自動処理には実行者が入らない）。
 *
 * 起案タスクは除く。差し戻し後に申請者が再提出すると、それが最後の人手タスクに
 * なって申請者が判定者に見えてしまう。
 *
 * 2 段承認では**最終判定者**になる（前段は履歴で辿る）。
 */
export function deriveDecidedBy(
  events: readonly CaseHistoryEvent[],
  config: CaseConfig,
): string | null {
  // 履歴は新しい順（id の降順）で渡ってくる
  const decided = events.find(
    (event) =>
      event.actor !== null && event.actor !== "" && !isDraftTask(event, config),
  );

  return decided?.actor ?? null;
}

function isDraftTask(event: CaseHistoryEvent, config: CaseConfig): boolean {
  const identifier = event.taskIdentifier;
  if (identifier === null) return false;

  return config.draftTaskNames.includes(identifier);
}
